import { setCurrentLocale } from '../plugins/i18n'
import { BasePlugin } from 'stylemix-base'
import { AdminPlugin } from 'stylemix-vue-admin'
import * as moment from 'moment'

const parseLocale = () => {
  const localeMatch = window.location.search.match(/^[?&]?lang=([a-z]*)/)
  if (localeMatch && localeMatch[1]) {
    return localeMatch[1]
  }
  return 'en'
}

export default {
  created() {
    /**
     * Set current locale after all modules loaded.
     * It will allow every module to register their message groups.
     */
    this.setLocale(parseLocale())

    this.$on('account-loaded', account => {
      // Allow to use preferred language for loaded user account
      if (account.language) {
        this.setLocale(account.language)
      }
    })
  },

  methods: {
    setLocale(locale) {
      return setCurrentLocale(locale).then(() => {
        moment.locale(locale)
        BasePlugin.setStrings(this.$i18n.t('vendor.base'))
        BasePlugin.setConfig({ locale })
        AdminPlugin.setStrings(this.$i18n.t('vendor.admin'))
        this.setReady()
      })
    },
  },
}
